import { apiJson, type ApiFetchInit } from "../../api/client";
import type { TeamMembersPage } from "../types";

export function getTeamMembers(
  params: { page?: number; size?: number } = {},
  init: ApiFetchInit = {},
): Promise<TeamMembersPage> {
  const page = params.page ?? 1;
  const size = params.size ?? 50;
  const qs = new URLSearchParams({ page: String(page), size: String(size) });
  return apiJson<TeamMembersPage>(`/team/members?${qs.toString()}`, init);
}

export function removeMember(
  memberId: string | number,
  init: ApiFetchInit = {},
): Promise<{ ok: true }> {
  return apiJson<{ ok: true }>(`/team/members/${encodeURIComponent(String(memberId))}`, {
    ...init,
    method: "DELETE",
  });
}

export function leaveTeam(init: ApiFetchInit = {}): Promise<{ ok: true }> {
  return apiJson<{ ok: true }>("/team/leave", {
    ...init,
    method: "POST",
  });
}
